import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './editors.intl.json';

export const useEditorsIntl = () => useIntlModule(messages);
